import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, patch } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";
import {
  DEFAULT_PROJECT_SETTINGS,
  parseProjectSettingsResponse,
} from "../../Pages/Projects/project-detail/settings/projectSettingsMapper";

/**
 * GET /projects/:projectId/settings
 */
export const fetchProjectSettings = createAsyncThunk(
  "projectSettings/fetch",
  async (projectId, { rejectWithValue }) => {
    const id = projectId != null && String(projectId).trim() !== "" ? String(projectId).trim() : "";
    if (!id) {
      return rejectWithValue("Project is required.");
    }
    try {
      const response = await get(API_ENDPOINTS.PROJECTS.GET_SETTINGS(id));
      return parseProjectSettingsResponse(response.data);
    } catch (error) {
      if (error?.response?.status === 404) {
        return { ...DEFAULT_PROJECT_SETTINGS };
      }
      return rejectWithValue(getApiErrorMessage(error, "Failed to load project settings"));
    }
  }
);

/**
 * PATCH /projects/:projectId/settings — body `{ general?: {}, notification?: {} }`
 */
export const updateProjectSettings = createAsyncThunk(
  "projectSettings/update",
  async ({ projectId, body }, { rejectWithValue }) => {
    const id = projectId != null && String(projectId).trim() !== "" ? String(projectId).trim() : "";
    if (!id) {
      return rejectWithValue("Project is required.");
    }
    if (!body || typeof body !== "object") {
      return rejectWithValue("Nothing to save.");
    }
    try {
      const response = await patch(
        API_ENDPOINTS.PROJECTS.PATCH_SETTINGS(id),
        body,
        {},
        {},
        { skipToast: true }
      );
      return {
        projectId: id,
        data: parseProjectSettingsResponse(response.data),
      };
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to save project settings"));
    }
  }
);
